module.exports = __webpack_public_path__ + "img/logo-list-6.b4198b6d.png";